export function userLabel(
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
): string {
  const name = [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ');
  return name || email?.trim() || 'Signed in user';
}
